import React from 'react';

import styled from '@emotion/styled';
import { mq, red01, fontEn, hoverFade } from '../../_style';
import Image from './image';
import { Link } from 'gatsby';


export default class Banner extends React.Component {
  render() {
    const Container = styled.a`
      display: block;
      ${hoverFade}
      ${this.props.isNew && `
        position: relative;
        &::before {
          content: "NEW";
          display: block;
          color: ${red01};
          font-family: ${fontEn};
          font-size: 12px;
          line-height: 1;
          position: absolute;
          top: -20px;
          left: 0;
        }
      `}
    `;
    const BannerLink = this.props.to && Container.withComponent(Link);
    const TagName = this.props.to ? BannerLink : Container;
    return (
      <TagName href={this.props.href ? this.props.href : null} to={this.props.to ? this.props.to : null} target={this.props.isBlank ? '_blank' : null}>
        <Image filename={this.props.img} alt={this.props.alt}></Image>
      </TagName>
    );
  }
}
